import BaseComponent from '@components/base-component';
import tag from '@components/utility-components';
import * as styles from './modal.module.scss';
export default class Modal extends BaseComponent {
    modalControls = {
        showModal: this.showModal.bind(this),
        closeModal: this.closeModal.bind(this),
        closeModalButton: tag.button({
            text: 'Cancel',
            classes: ['button', styles.cancelBtn],
            onclick: this.closeModal.bind(this),
        }),
    };
    content;
    constructor() {
        super({ elementTag: 'dialog', classes: [styles.modal] });
        this.addListeners();
    }
    showModal(component) {
        this.createModal();
        document.body.append(this.getElement());
        if (this.content)
            this.content.getElement().replaceChildren(component.getElement());
        this.element.showModal();
    }
    createModal() {
        this.content = tag.div({ classes: [styles.content] });
        this.appendSingle(this.content);
    }
    addListeners() {
        this.addListener('click', (event) => {
            if (event.target === event.currentTarget)
                this.element.close();
        });
        this.addListener('close', () => {
            this.content?.removeSelf();
            this.getElement().remove();
        });
    }
    closeModal(event) {
        event.preventDefault();
        this.getElement().close();
        this.content?.removeSelf();
        this.getElement().remove();
    }
}
